import React from "react";
import { observer } from "mobx-react";
import { Nav } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";



@observer
export class DeliveryPointLayout extends React.Component<any, any> {

    render() {

        return <div>
            <Nav variant="tabs" defaultActiveKey="/deliverypoint/demands/1">
                <LinkContainer to="/deliverypoint/demands/1">
                    <Nav.Item>
                        <Nav.Link href="/deliverypoint/demands/1">Отгрузки</Nav.Link>
                    </Nav.Item>
                </LinkContainer>
                <LinkContainer to="/deliverypoint/acceptances/1">
                    <Nav.Item>
                        <Nav.Link href="/deliverypoint/acceptances/1">Приемки</Nav.Link>
                    </Nav.Item>
                </LinkContainer>
            </Nav>

            <div>
                {this.props.children}
            </div>
        </div>;
    }
}